<template>
  <div v-if="dialogVisible">
    <el-dialog
      class="dialog-choose-position-sign"
      top="10px"
      title="Chọn ảnh và vị trí ký"
      :visible.sync="dialogVisible"
      width="95%"
      :before-close="dialogBeforeClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="dialog-body mb-3">
        <div class="list-sign-image" id="selectorContainer">
          <el-radio-group
            v-model="model"
            class="radio-group"
            @change="changeSignImage(model)"
          >
            <el-radio
              v-for="(item,index) in fileUploadOption.FileChuKy.listImageSigns"
              :key="index"
              :label="item.sign_image_id"
            >
              <div class="border-image">
                <!-- <div class="sign-again">
                  <i class="isax-refresh"></i>
                </div> -->
                <el-image
                  :src="item.url"
                  fit="cover"
                ></el-image>
              </div>
            </el-radio>
          </el-radio-group>
          <div class="border-image">
            <el-upload
              v-if="showUpload"
              :auto-upload="false"
              drag
              action
              multiple
              :on-change="fn_uploadSign"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Kéo vào đây <br/> hoặc <em>click để upload</em>
              </div>
            </el-upload>
            <div class="el-upload__tip" slot="tip">
              <i>Chỉ chấp nhận File có định dạng PNG và chiều cao, chiều rộng không quá 220px</i>
            </div>
          </div>
        </div>
        <div class="pdf-content" id="pdf-content">
          <div class="
            canvas
            text-center
            pdfViewer
            singlePageView
            nopadding"
          >
            <div class="dropzone" style="max-width: 833px;">
              <Draggable
                v-if="!changedSignImage"
                @endDragSign="endDragSign"
                @removeSignImage="removeSignImage"
                :imageSignId="model"
                :pageNum="pageNum"
                :positionSign="dataObject.position"
                :currentPage="pageNum"
                :from="'DrafDocument'"
              />
              <!-- <canvas id="the-canvas"></canvas> -->
              <ViewPdf
                @changePageNum="changePageNum"
                @canvasDimensions="handleCanvasDimensions"
                @pdfSize="handlePdfSize"
                :fileId="pdfFileId"
                :currentPage="pageNum"
                :pageSign="pageSigned"
              />
            </div>
          </div>
          <!-- <el-button class="button-nav" id="prev" @click="onPrevPage">
            <i class="el-icon-arrow-left"></i>
          </el-button>
          <el-button class="button-nav" id="next" @click="onNextPage">
            <i class="el-icon-arrow-right"></i>
          </el-button> -->
        </div>
      </div>

      <div class="footer-dialog">
        <div class="history-sign">
          <div
            class="history-sign__content"
            v-if="haveHistory"
          >
            <span class="mr-2">
              Chữ ký
            </span>
            <el-image
              class="go-to-sign"
              title="Đi đến trang ký"
              @click="jumpToPage(historySign.pageSigned)"
              style="width: 70px;"
              :src="ExtensionService.urlImg + historySign.imageSignId"
              fit="cover"
            ></el-image>
            <span class="ml-2">
              tại trang
              <b>{{historySign.pageSigned}}</b>
            </span>
          </div>
        </div>
        <div class="paging ml-26 text-center">
          <p>
            Trang
            <el-input-number
              class="current-page ml-1 mr-1"
              :controls="false"
              v-model="pageNum"
              @change="changePage(pageNum)"
              :min="1"
              :max="numPages"
              :disabled="numPages === 1"
            ></el-input-number>
            / {{numPages}}
          </p>
        </div>
        <div class="button-action__group ">
          <el-button
            type="danger"
            plain
            @click="closeDialog"
          >
            {{dataObject.sign_image_id ? 'Đóng' : 'Hủy'}}
          </el-button>
          <el-button
            type="primary"
            plain
            @click="submit"
            :disabled="!model"
          >
            Xác nhận
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ExtensionService from '@/service/ExtensionService';
import MethodService from '@/service/MethodService';
import EmployeeSignatureApi from '@/moduleApi/EmployeeSignatureApi';
import Draggable from '@/component/Draggable/Draggable';
import ViewPdf from '@/component/Draggable/ViewPdf';
import EventBus from "@/service/EventBus";

export default {
  components: {
    Draggable,
    ViewPdf
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {false}
    },
    dataObject: {
      type: Object,
      default: () => ({})
    },
    pdfFileId: {
      type: String,
      default: ''
    },

  },
  data() {
    return {
      ExtensionService,
      height: window.innerHeight - 218,
      model: undefined,
      changeImageIdProp: false,
      listEmployeeSignatures: [],
      fileUploadOption: {
        FileChuKy: {
          accept: ".png",
          dialogImageUrl: "",
          listImageSigns: []
        }
      },
      pdfDoc: null,
      pageNum: 0,
      pageSigned: 0,
      numPages: 0,
      pageRendering: false,
      pageNumPending: null,
      scale: 1.4,
      widthCanvas: 0,
      changedSignImage: true,
      historySign: {
        imageSignId: undefined,
        pageSigned: 0,
        positionX: 0,
        positionY: 0,
        width: 0,
        height: 0
      },
      haveHistory: false,
      companyInfo: MethodService.getCompanyInfo(),
      arrUploadImage: [],
      promisesUpload: [],
      fileList: [],
      promisesCheckSizeImage: [],
      showUpload: true,
      canvasDimensions: { width: 0, height: 0 },
      pdfSize: { width: 0, height: 0 }
    }
  },
  methods: {
    removeSignImage() {
      this.model = undefined;
      this.changedSignImage = true;
      this.haveHistory = false;
      this.historySign = {
        imageSignId: undefined,
        pageSigned: 0,
        positionX: 0,
        positionY: 0,
        width: 0,
        height: 0
      };
    },
    jumpToPage(toPage) {
      this.pageNum = toPage;
      // this.pageSigned = toPage;
    },
    changePage(pageNum) {
      this.pageNum = pageNum;
    },
    scrollToTop(){
      document.getElementById("pdf-content").scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    showChangeSignImage() {
      setTimeout(() => {
        this.changedSignImage = false
        setTimeout(() => {
          EventBus.$emit('changeImageIdEvent')
        }, 100)
      }, 600)
    },
    async changeSignImage(imageSignId) {
      this.scrollToTop()
      const img = new Image()
      img.src = ExtensionService.urlImg + imageSignId
      if (
        (this.historySign.imageSignId &&
        this.historySign.imageSignId != imageSignId ) ||
        this.historySign.pageSigned != this.pageNum
      ) {
        this.changedSignImage = true
        this.showChangeSignImage()
      } else {
        this.showChangeSignImage()
      }
      this.historySign.imageSignId = imageSignId
      this.historySign.pageSigned = this.pageNum
      this.historySign.positionX = 0
      this.historySign.positionY = 0
      this.historySign.width = img.width || 220
      this.historySign.height = img.height || 220
      this.dataObject.position = {
        page_index: this.historySign.pageSigned,
        x: this.historySign.positionX,
        y: this.historySign.positionY,
        width: this.historySign.width,
        height: this.historySign.height,
      }
      this.checkHaveHistorySign()
    },
    endDragSign(data) {
      this.historySign.imageSignId = data.imageSignId;
      this.historySign.pageSigned = data.pageSigned;
      this.historySign.positionX = data.positionX;
      this.historySign.positionY = data.positionY;
      this.historySign.width = data.width;
      this.historySign.height = data.height;
      this.checkHaveHistorySign();
    },
    async getEployeeSign(data) {
      this.resetNumpage();
      // this.fileUploadOption.FileChuKy.listImageSigns = [];
      Promise.all([this.promisesGetEmployeeSign(data)]).then(apiRes => {
        if (apiRes[0][0]) {
          if (!apiRes[0][0].image_ids) {
            apiRes[0][0].image_ids = [];
          }
          this.listEmployeeSignatures = apiRes[0][0];
        } else {
          this.listEmployeeSignatures = {
            employee_id: data.user_id,
            image_ids: Array(0)
          };
        }
        (this.listEmployeeSignatures.image_ids || []).forEach(item => {
          let checkHaveImage = this.fileUploadOption.FileChuKy.listImageSigns.find(
            image => image.sign_image_id == item
          );
          if (checkHaveImage) return
          this.fileUploadOption.FileChuKy.listImageSigns.push({
            sign_image_id: item,
            url: ExtensionService.urlImg + item
          })
        })
      })
    },
    async promisesGetEmployeeSign(data) {
      this.promisesCheckSizeImage = [];
      const employeeSignatureApiRes = await EmployeeSignatureApi.list({
        filters: `employee_id=${data.user_id}`,
      });
      return employeeSignatureApiRes.result
    },
    dialogBeforeClose() {
      // this.dialogVisible = false;
      this.historySign = {
        imageSignId: undefined,
        pageSigned: 0,
        positionX: 0,
        positionY: 0,
        width: 220,
        height: 0
      };
      this.arrUploadImage = [];
      this.promisesUpload = [];
      this.promisesCheckSizeImage = [];
      this.fileUploadOption.FileChuKy.listImageSigns = [];
      this.resetNumpage();
      console.log('this.dataObject', this.dataObject);
      this.$emit('close', {
        userId: this.dataObject.user_id,
        derpartmentId: this.dataObject.department_id,
      });
      // this.dataObject = {};
    },
    closeDialog() {
      // this.dialogVisible = false;
      this.arrUploadImage = [];
      this.promisesUpload = [];
      this.promisesCheckSizeImage = [];
      this.fileUploadOption.FileChuKy.listImageSigns = [];
      this.resetNumpage();
      this.$emit('close', {
        userId: this.dataObject.user_id,
        derpartmentId: this.dataObject.department_id,
      });
      // this.dataObject = {};
    },
    submit() {
      if (!this.pdfSize || !this.canvasDimensions.width) {
        toastr.error("Không thể xác định kích thước tài liệu");
        return;
      }

      // Convert from canvas pixels (at scale 1.4) to "96 DPI pixels" 
      // (The backend legacy logic expects coordinates scaled to a 96 DPI virtual page)
      // A4 points: 595x842. A4 96DPI: 793.3x1122.6. Ratio: 96/72 = 1.333
      const DPI_RATIO = 96 / 72;
      const targetWidth = this.pdfSize.width * DPI_RATIO;
      const targetHeight = this.pdfSize.height * DPI_RATIO;
      
      const canvasW = this.canvasDimensions.width;
      const canvasH = this.canvasDimensions.height;
      const BE_DELTA = 0.95;

      this.dataObject.sign_image_id = this.historySign.imageSignId;
      
      this.dataObject.position = {
        x: Math.round((this.historySign.positionX * targetWidth) / canvasW),
        y: Math.round((this.historySign.positionY * targetHeight) / canvasH),
        delta_x: this.historySign.positionX,
        delta_y: this.historySign.positionY,
        page_index: this.historySign.pageSigned,
        width: Math.round((this.historySign.width * targetWidth / canvasW) / BE_DELTA),
        height: Math.round((this.historySign.height * targetHeight / canvasH) / BE_DELTA)
      }
      this.resetNumpage();
      this.$emit('submitClose', this.dataObject);
    },
    resetNumpage(){
      this.model = undefined;
      this.pageNum = 0;
      this.historySign = {
        imageSignId: undefined,
        pageSigned: 0,
        positionX: 0,
        positionY: 0,
        width: 220,
        height: 0
      }
    },
    promisesUploadAsync() {
      Promise.all(this.promisesUpload).then(valueUpload => {
        if (valueUpload.length  == this.arrUploadImage.length) {
          valueUpload.forEach(async item => {
            this.promisesCheckSizeImage.push(MethodService.checkWidthHeightImage(item.result, 220, 220));
          })
          Promise.all(this.promisesCheckSizeImage).then(status => {
            let checkFailed = status.find(item => !item.status);
            let checkSuccess = status.filter(item => item.status);
            if (checkFailed) {
              toastr.warning(checkFailed.message ? checkFailed.message : "Kích thước ảnh không hợp lệ");
            }
            let lengthImageIdsBefore = this.listEmployeeSignatures.image_ids ? this.listEmployeeSignatures.image_ids.length : 0;
            (checkSuccess || []).forEach(item => {
              let checkHaveImage = this.fileUploadOption.FileChuKy.listImageSigns.find(
                image => image.sign_image_id == item.file_id
              );
              if (checkHaveImage) return
              this.listEmployeeSignatures.image_ids.push(item.file_id);
              this.fileUploadOption.FileChuKy.listImageSigns.push({
                sign_image_id: item.file_id,
                url: ExtensionService.urlImg + item.file_id
              });
            })
            let lengthImageIdsAfter = this.listEmployeeSignatures.image_ids ? this.listEmployeeSignatures.image_ids.length : 0;
            // console.log("this.fileUploadOption.FileChuKy.listImageSigns",
            //   JSON.stringify(this.fileUploadOption.FileChuKy.listImageSigns)
            // );
            this.reloadUploadDrag();
            if (lengthImageIdsAfter > lengthImageIdsBefore) {
              this.updateEmployeeSign();
            }
          })
        }
      })
    },
    async fn_uploadSign(file, fileList) {
      this.arrUploadImage.push(file);
      this.fileList = fileList;
      if (!this.checkTypeImageBeforeUpload(file)) {
        toastr.warning("Chỉ được tải lên file ảnh có định dạng PNG");
        fileList = fileList.filter(item => item.uid != file.uid);
        this.arrUploadImage = this.arrUploadImage.filter(item => item.uid != file.uid);
        if (fileList.length == 0) {
          this.reloadUploadDrag();
        }
        return
      }
      this.promisesUpload.push(ExtensionService.upload(file, "ChuKyNhanVien"));
      if (this.arrUploadImage.length == this.fileList.length) {
        this.promisesUploadAsync();
      }
    },
    reloadUploadDrag() {
      this.showUpload = false;
      setTimeout(() => {
        this.showUpload = true;
      }, 100);
      this.promisesUpload = [];
      this.arrUploadImage = [];
      this.promisesCheckSizeImage = [];
    },
    checkTypeImageBeforeUpload(file) {
      return (file.raw && file.raw.type == "image/png")
    },
    async updateEmployeeSign() {
      // this.showUpload = false;
      try {
        let data = MethodService.copyObject(this.listEmployeeSignatures);
        if (data.id) {
          await EmployeeSignatureApi.update(data);
          toastr.success("Cập nhật chữ ký thành công");
          this.getEployeeSign(this.dataObject);
          this.showUpload = true;
        } else {
          data.company_id = this.companyInfo.id;
          await EmployeeSignatureApi.create(data);
          toastr.success("Cập nhật chữ ký thành công");
          this.getEployeeSign(this.dataObject);
          this.showUpload = true;
        }
      } catch (error) {
        toastr.error("Cập nhật chữ ký thất bại");
      }
    },
    changePageNum(data) {
      this.pageNum = data.pageNum;
      this.numPages = data.numPages;
      if (this.historySign.pageSigned == data.pageNum) {
        this.model =  this.historySign.imageSignId;
      } else {
        this.model = undefined;
      }
      this.scrollToTop();
    },
    handleCanvasDimensions(dims) {
      this.canvasDimensions = dims;
    },
    handlePdfSize(size) {
      this.pdfSize = size;
    },
    checkHaveHistorySign() {
      this.haveHistory = false;
      if (this.historySign.imageSignId) {
        this.haveHistory = true;
      } else {
        this.haveHistory =  false;
      }
    }
  },
  watch: {
    dataObject(newVal, oldVal) {
      setTimeout(() => {
        if (this.dataObject.sign_image_id) {
          this.model = this.dataObject.sign_image_id;
          this.historySign = {
            imageSignId: this.dataObject.sign_image_id,
            pageSigned: this.dataObject.position.page_index,
            positionX: this.dataObject.position.x,
            positionY: this.dataObject.position.y,
            width: this.dataObject.position.width || 220,
            height: this.dataObject.position.height || 0,
          }
          console.log('zooo watch dataObject');
          this.checkHaveHistorySign()
          this.showChangeSignImage()
        }
      }, 1000)
    },
    dialogVisible(newVal, oldVal) {
      if (newVal === true) {
        this.pageNum++;
        this.getEployeeSign(this.dataObject);
        this.checkHaveHistorySign();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding-bottom: 10px;
}
.ml-26 {
  margin-left: 26rem;
}
::v-deep .dialog-choose-position-sign {
  .el-dialog {
    margin-bottom: 8px;
  }
}
::v-deep .dialog-body {
  display: flex;
  .list-sign-image {
    width: 300px;
    padding:0 10px;
    min-height: calc(100vh - 200px);
    max-height: calc(100vh - 190px);
    overflow-y: auto;
    .radio-group {
      display: flex;
      flex-direction: column;
      .el-radio {
        position: relative;
        .el-radio__input {
          position: absolute;
          top: -3px;
          left: -15px;
          background-color: #fff;
          padding: 7px;
          border-radius: 50%;
          &.is-checked + .el-radio__label {
            color: #5E9BBC;
          }
          &.is-checked {
            .el-radio__inner {
              border-color: #5E9BBC;
              background: #fff;
            }
          }
          .el-radio__inner {
            width: 24px;
            height: 24px;
            border-color: #5E9BBC;
            &:hover {
              border-color: #5E9BBC;
            }
            &::after {
              width: 16px;
              height: 16px;
              background-color: #5E9BBC;
              border-color: #5E9BBC;
            }
          }
        }
      }
      .border-image {
        border: 1.5px solid #5E9BBC;
        border-radius: 2px;
        padding: 10px;
        text-align: center;
        // position: relative;
        .el-image {
          max-width: 300px;
        }
        .el-upload-dragger {
          max-width: 200px;
          height: 200px;
          border-radius: 50%;
          border-width: 2px;
          .el-upload__text {
            line-height: 20px;
          }
        }
      }
    }
  }
  .border-image {
    border: 1.5px solid #5E9BBC;
    border-radius: 2px;
    padding: 10px;
    text-align: center;
    .el-image {
      max-width: 300px;
    }
    .el-upload-dragger {
      max-width: 200px;
      height: 200px;
      border-radius: 50%;
      border-width: 2px;
      .el-upload__text {
        line-height: 20px;
      }
    }
    .el-upload-list {
      display: none;
    }
    .el-upload__tip {
      font-size: 13px;
    }
  }
  .pdf-content {
    margin-left: 30px;
    width: 100%;
    position: relative;
    min-height: calc(100vh - 200px);
    max-height: calc(100vh - 190px);
    overflow-y: auto;
    .dropzone {
      margin: 0 auto;
      position: relative;
    }
    .image-drag {
      position: absolute;
      top: 0;
      left: 20%;
    }
    .canvas {
      #the-canvas {
        border: 1px dashed #d3d4d4;
      }
    }
    .button-nav {
      width: 50px;
    }
    #prev {
      position: fixed;
      top: 50%;
      left: 340px;
    }
    #next {
      position: fixed;
      top: 50%;
      right: 100px;
    }
  }
}
::v-deep .current-page {
    width: 50px !important;
    .el-input {
      .el-input__inner {
        padding-left: 5px;
        padding-right: 5px;
      }
    }
  }
.footer-dialog {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .history-sign {
    min-width: 230px;
    .history-sign__content {
      display: flex;
      align-items: center;
      .go-to-sign {
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  .paging {
    p {
      font-size: 15px;
    }
  }
}

</style>
